import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import LinkBtn from '../../../../components/inc/LinkBtn'; 
import NavigationHeder from '../../../../components/Navigations/NavigationHeder';
import Helper from '../../../../inc/Helper';
import Settings from '../../../../inc/Settings';
import { exportToXlsx, getPopupMessageBasedOnStatus } from '../../../../inc/Validation';
import AgGridNew from '../../../../components/grid/ag/ag-grid-new';
import MasterComponentWraper from '../../../../components/Backend/MasterComponentWraper';
import { connect } from 'react-redux';
import { generateBaseUrl, getLabelFromDropdown, getOptions, optionsKeyCreator } from '../../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import { transformObjectTemplates } from '../../../../inc/TransformerFunctions';
import SimpleDropdown from '../../../../components/grid/ag/cellEditor/SimpleDropdown';
import NewOverlayLoader from '../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Api from '../../../../inc/Api';

let gridApi = null;
let AddBtn;
let transaction;

const Template = (props) => {
  const [exportLoading, setExportLoading] = useState(false);
  const [sourcesList, setSourcesList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => { getSourcesData() }, []);

  const getSourcesData = () => {
    axios.get(Settings.apiUrl + `/source?for_workflow=${true}`).then((res) => {
      if (res.data.status === "success") {
        setSourcesList(res?.data?.data?.map(item => {
          return {
            value: item.source_id,
            label: item.source_name
          }
        }));
      };
    }).catch((res) => {
      console.log(res)
    });
  };

  const handleBtn = (value, transactionData) => {
    AddBtn = value
    transaction = transactionData
  };

  const onRowValueChanged = (event) => {  
    if (!event?.data?.template_id) {
      addTemplate(event);
    } else {
      updateTemplate(event);
    }
  };

  const addTemplate = async (event) => {
    try {
      let payload = [{
        tenant_id: props?.user?.tenant_id,
        module_id: event?.data?.module_id,
        name: event?.data?.name,
        description: event?.data?.description
      }];
 
      let api = Api;
      api.setUserToken()
      const res = await api.axios().post(Settings.baseUrl + 'stage/create', payload);
      if (res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        setTimeout(() => {
          if (AddBtn) {
            gridApi?.api?.applyServerSideTransaction(transaction);
          }
        }, 1000);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error);
    }  
  };

  const updateTemplate = async (event) => {
    try {
      let payload = [{
        template_id: event?.data?.template_id,
        field_dictionary: [],
        module_id: event?.data?.source_id,
        name: event?.data?.name,
        description: event?.data?.description
      }];
  
      let api = Api;
      api.setUserToken()
      const res = await api.axios().post(Settings.baseUrl + 'template/update', payload);
      if (res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error);
    }
  };

  const onDeleteTemplate = useCallback(async (element) => {
    try {
      let api = Api;
      api.setUserToken()
      const res = await
        api.axios()
        .post(Settings.baseUrl + 'template/delete', { template_id: [element?.data?.template_id] })
      const rowNode = gridApi?.api?.getRowNode(element?.data?.template_id)
      if (rowNode) {
        rowNode.setSelected(false)
      }

      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.api?.applyServerSideTransaction(transaction)
      }, 200);

      gridApi?.api?.refreshServerSide({ purge: true })
      gridApi?.api?.deselectAll();

      Helper.alert(res?.data?.message, 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);
 
  const gridModifyButton = () => {
    return <div className="rs_active_label">Modify</div>;
  };

  const gridColumnHeader = [
    { field: 'name', headerName: 'Name', editable: true },
    {
      field: 'module_id',
      headerName: 'Source',
      editable: true,
      cellEditor: SimpleDropdown,
      isAllowZero:true,
      inputId: 'source_module_id',
      minWidth:180,
      cellEditorParams: {
        values: sourcesList
      },
      cellDataType:false,
      valueFormatter: (params)=> getLabelFromDropdown(params),
      filter:'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, sourcesList),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    },
    { field: 'description', headerName: 'Description', editable: true },
    { field: 'modify_btn', headerName: 'Action', editable: false, cellRenderer: gridModifyButton }
  ];

  const onCellClicked = (event) => {
    if (event.colDef.field === "modify_btn") {
      if (event.data.template_id === 0) return;
      navigate(`/template/edit?id=${event.data?.template_id}`);
    };
  };

  const getTransformedObjForExport = (data) => transformObjectTemplates(data, sourcesList);

  const exportData = async () => {
    setExportLoading(true);

    const apiUrl = Settings.baseUrl + 'template/get-all';
    const params = '';

    let pagination = false;
    let defaultAdvanceFilterObj = false; 

    const baseUrl = generateBaseUrl({ gridObj: gridApi, apiUrl, params, pagination, defaultAdvanceFilterObj });
    await exportToXlsx({ url: baseUrl, columns: (gridColumnHeader?.filter(item => item.field !== 'modify_btn')), fileName: "template_details", additionalFunction: getTransformedObjForExport, apiTokenRequired: false });
    
    setExportLoading(false);
  };

  return (
    <>
      <NavigationHeder hideBackButton={true}>
        <LinkBtn to={'/template/edit'} title='Add Template With Fields' />
      </NavigationHeder>

      {exportLoading ? <NewOverlayLoader /> : null}
 
      <AgGridNew
        apiUrl={Settings.baseUrl + 'template/get-all'}
        pagination={false}
        columnDefs={gridColumnHeader}
        onRowValueChanged={onRowValueChanged}
        onCellClicked={onCellClicked}
        hideDeleteBtn={true}
        handleDeleteSelectedRows={onDeleteTemplate}
        height={500}
        hideDeleteBtn={true}
        onGridReady={(params) => gridApi = params}
        handleAddButton={handleBtn}
        uniqueField={`template_id`}
        apiTokenRequired={false}
        gridId={'templates-workflow-forms'}
        afterDeleteBtns={
          <div className="import_sample_template px-2">
            <button onClick={exportData}>
              <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
            </button>
          </div>
        }
        btnsWrapperStyle="w-100 px-2"
      />
    </>
  )
}
 
const mapStateToProps = (state) => {
  return { 
    user: state.auth.user
  }
};

export default connect(mapStateToProps) (MasterComponentWraper(Template));